import type { PingKind } from '../../shared/network/pings.js';
import type { HudIcon } from './icons.js';

/** The ring of this player's pings, and of the other player's. */
export const PING_GILT = 0xe2bd6e, PING_SILVER = 0xc6ccd4;
/** Each kind's glyph and the colour its ripples and glyph are lit in: gilt for plain marks, ember for threats, cool for watching, green for aid. */
export const PING_LOOKS: Record<PingKind, { icon: HudIcon; color: number; label: string }> = {
  mark: { icon: 'focus', color: 0xe8c47a, label: 'Mark' },
  rally: { icon: 'rally', color: 0xe8c47a, label: 'Rally here' },
  attack: { icon: 'strike', color: 0xe07a5c, label: 'Attack' },
  danger: { icon: 'hazard', color: 0xe8653a, label: 'Danger' },
  watch: { icon: 'watch', color: 0xa9c9d4, label: 'Watch' },
  defend: { icon: 'shield', color: 0xc9d1a8, label: 'Defend' },
  heal: { icon: 'mend', color: 0x9fd39a, label: 'Heal' },
};
